(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("prop-types"), require("uuid/v4"), require("lodash.omit"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "prop-types", "uuid/v4", "lodash.omit"], factory);
	else if(typeof exports === 'object')
		exports["main"] = factory(require("react"), require("prop-types"), require("uuid/v4"), require("lodash.omit"));
	else
		root["main"] = factory(root["React"], root["PropTypes"], root["uuid"], root["_.omit"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_6__, __WEBPACK_EXTERNAL_MODULE_8__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition